/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmd_AssigneeInputs */

const en_cmd_assignee = /** @type {(inputs: Cmd_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign`)
};

const de_cmd_assignee = /** @type {(inputs: Cmd_AssigneeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuweisen`)
};

/**
* | output |
* | --- |
* | "Assign" |
*
* @param {Cmd_AssigneeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cmd_assignee = /** @type {((inputs?: Cmd_AssigneeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmd_AssigneeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cmd_assignee(inputs)
	return en_cmd_assignee(inputs)
});